import { call, put, takeLatest } from 'redux-saga/effects';
import { AIAnalysisActions, fetchAIAnalysisFailure, fetchAIAnalysisSuccess } from './actions';
import api from '../../../api-new/http';
import { appUrls } from '../../../api-new/urls';
import { FETCH_AI_ANALYSIS_REQUEST } from './constants';
import { sendError } from '../../public/errorHandler';
import { getErrorSetup } from '../../../helpers/getErrorSetup';
import { exportToExcel } from '../../../helpers/downloadAnalyisData';
import { StockAnalysisData } from './types';

export function* aiAnalysisSaga(action: AIAnalysisActions) {
    try {
        const data = yield call(() =>
            api.get(`${appUrls.tradeURL}/chat/${action.payload}`, {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem('csrfToken')}`,
                },
            }),
        );
        if (data) {
            const responseData = data.data.data as StockAnalysisData;
            const updatedData = {
                ...responseData,
                BasicInformation: { ...responseData.BasicInformation, TradingDate: new Date().toLocaleDateString() },
            };
            yield put(fetchAIAnalysisSuccess(updatedData));

            exportToExcel(updatedData);
        }
    } catch (error) {
        yield put(fetchAIAnalysisFailure(error as any));
        yield put(
            sendError({
                error: getErrorSetup(error),
                processingType: 'alert',
            }),
        );
    }
}

export function* rootAIAnalysisSaga(): Generator {
    yield takeLatest(FETCH_AI_ANALYSIS_REQUEST, aiAnalysisSaga);
}
